import { render, staticRenderFns } from "./SelProduto.vue?vue&type=template&id=fd46ca00"
import script from "./SelProduto.vue?vue&type=script&lang=js"
export * from "./SelProduto.vue?vue&type=script&lang=js"
import style0 from "./SelProduto.vue?vue&type=style&index=0&id=fd46ca00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports